import { BlockquoteBlock } from "../../components/markdown/BlockquoteBlock";
import { CodeBlockWithExtendedSupport } from "../../components/markdown/CodeBlockWithExtendedSupport";
import { H1Block, H2Block, H3Block, H4Block, H5Block, H6Block, } from "../../components/markdown/HeadingBlock";
import { HrBlock } from "../../components/markdown/HrBlock";
import { InputBlock } from "../../components/markdown/InputBlock";
import { LinkBlock } from "../../components/markdown/LinkBlock";
import { LiBlock, OlBlock, UlBlock } from "../../components/markdown/List";
import { ParagraphBlock } from "../../components/markdown/ParagraphBlock";
import { PreBlock } from "../../components/markdown/PreBlock";
import { StrongBlock } from "../../components/markdown/StrongBlock";
import { TableBlock, TableBodyBlock, TableDataBlock, TableHeadBlock, TableHeaderBlock, } from "../../components/markdown/TableBlock";
import { pickMarkdownBlock } from "../../components/markdown/utils";
export function createBaseMarkdownComponents(optimizeForStreaming) {
    const pick = (optimizedBlock) => pickMarkdownBlock(optimizedBlock, optimizeForStreaming);
    return {
        pre: pick(PreBlock),
        a: pick(LinkBlock),
        ul: pick(UlBlock),
        ol: pick(OlBlock),
        li: pick(LiBlock),
        p: pick(ParagraphBlock),
        h1: pick(H1Block),
        h2: pick(H2Block),
        h3: pick(H3Block),
        h4: pick(H4Block),
        h5: pick(H5Block),
        h6: pick(H6Block),
        table: pick(TableBlock),
        thead: pick(TableHeadBlock),
        tbody: pick(TableBodyBlock),
        th: pick(TableHeaderBlock),
        td: pick(TableDataBlock),
        strong: pick(StrongBlock),
        input: pick(InputBlock),
        blockquote: pick(BlockquoteBlock),
        hr: pick(HrBlock),
        code: pick(CodeBlockWithExtendedSupport),
    };
}
//# sourceMappingURL=createBaseMarkdownComponents.js.map